// extracted by mini-css-extract-plugin
module.exports = {"infoLink":"Register_infoLink__1JDtg","mainTitle":"Register_mainTitle__2xrkQ"};